<template>
	<div class="sidebar-mobile" v-if="$auth.ready() && $auth.check()">
		<div class="main-menu">
			<div class="item-menu" :title="$t('menu.dashboard')">
				<router-link :to="{name: 'dashboard', params: { slug: $auth.user().slug} }" v-bind:class="{active: $route.name == 'homepage'}">
					<img src="/build/icons/daily-plan.svg" class="inactive-icon">
					<img src="/build/icons/daily-plan-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu" :title="$t('menu.goals')">
				<router-link :to="{name: 'master-goals' }" v-bind:class="{active: $route.name == 'show-master-goal'}">
					<img src="/build/icons/master-goals.svg" class="inactive-icon">
					<img src="/build/icons/master-goals-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu" :title="$t('menu.objectives')">
				<router-link :to="{name: 'objectives' }" v-bind:class="{active: $route.name == 'show-objective'}">
					<img src="/build/icons/objectives.svg" class="inactive-icon">
					<img src="/build/icons/objectives-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu" :title="$t('menu.people')">
				<router-link :to="{name: 'users' }" v-bind:class="{active: $route.name == 'show-user'}">
					<img src="/build/icons/people.svg" class="inactive-icon">
					<img src="/build/icons/people-red.svg" class="active-icon">
				</router-link>
			</div>
			<div class="item-menu">
				<div class="logout-action" @click="logout"><icon-logout /></div>
			</div>
		</div>
	</div>
</template>

<script>
	import IconLogout from '../Icons/Logout'

	export default {
		data() {
			return {
			};
		},
		components: {
			IconLogout
		},
		watch: {
		},
		mounted() {

		},
		methods: {
			logout(){
				this.$auth.logout();
			}
		},
		computed:{}
	};
</script>